import React, { useState, useEffect } from "react";
import { Button } from "../../Components/Verify/index";
import { connect } from "react-redux";
import { ReactComponent as Back } from "../../assets/icons/arrow_forward-24px.svg";
import { getUser, setToken, login } from "../../Redux/Actions/Authentication";
import { useHistory } from "react-router-dom";

const Verify = ({ ...props }) => {
  const { mobile, getUser, setToken, login, isLogin } = props;
  const [code, setCode] = useState("");
  const history = useHistory();
  const standalone = window.matchMedia("(display-mode: standalone)").matches;
  useEffect(() => {
    if (standalone) {
      history.push("/addtohome");
    } else if (isLogin) {
      history.push("/Main");
    }
  }, []);
  useEffect(() => {
    var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    (window.orientation == 90 || window.orientation == -90) &&
      isMobile &&
      history.push("/rotate");
    window.addEventListener(
      "orientationchange",
      function () {
        var isForbidden =
          (window.orientation == 90 || window.orientation == -90) && isMobile;
        if (isForbidden) {
          history.push("/rotate");
        }
      },
      false
    );
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);
  return (
    <div className="Container">
      <div className="mobileContainer">
        <div className="LoginPage">
          <img
            src={require("../../assets/images/loginBG@3x.png")}
            // className="LoginBackground"
          />
          <div>
            <div className="BackIcon" onClick={() => history.push("/Login")}>
              <Back />
            </div>
            <span
              className="LoginText"
              id="Billhistory"
            >{`کد فعالسازی برای شماره ${mobile} ارسال شد`}</span>
            <input
              type="number"
              id="Billhistory"
              pattern="[0-9]*"
              autoComplete={false}
              maxLength={5}
              value={code}
              onChange={(event) => setCode(event.target.value)}
              placeholder={"کد فعال‌سازی را وارد نمائید"}
              className="PhoneInput"
            />

            <Button
              mobile={mobile}
              code={code}
              getUser={getUser}
              setToken={setToken}
              login={login}
            />
            <span
              className="Coop"
              id="MinMaxSpan"
              style={{ animationDelay: "0.5s", opacity: 0 }}
            >
              با همراهی:
            </span>
            <span
              className="Zarin"
              id="MinMaxSpan"
              style={{ animationDelay: "0.5s", opacity: 0 }}
            >
              شرکت گنجینه زرین سپهر
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    mobile: state.auth.mobile,
    isLogin: state.auth.isLogin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getUser: (userInfo) => dispatch(getUser(userInfo)),
    setToken: (token) => dispatch(setToken(token)),
    login: () => dispatch(login(true)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Verify);
